import { useEffect, useMemo, useState } from "react";
import { HALO_PRICING_RELEASE_APPROVED } from "@/config/haloStorefront";
import { buildFortressStorefront } from "@/config/fortressStorefront";
import { fetchConsumerCatalog } from "@/lib/consumerCommerce";

/**
 * Fortress storefront hydrated from the consumer-platform catalog.
 * While HALO_PRICING_RELEASE_APPROVED is false the catalog is not even read:
 * the storefront stays closed/notify and no commerce call is made.
 */
export function useFortressStorefront() {
  const [catalog, setCatalog] = useState(null);
  const [catalogReady, setCatalogReady] = useState(false);

  useEffect(() => {
    if (!HALO_PRICING_RELEASE_APPROVED) return undefined;
    let cancelled = false;
    fetchConsumerCatalog()
      .then((data) => {
        if (!cancelled) {
          setCatalog(data);
          setCatalogReady(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCatalog(null);
          setCatalogReady(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const storefront = useMemo(() => buildFortressStorefront(process.env, catalog), [catalog]);
  return { storefront, catalog, catalogReady };
}
